import { render } from "./AdvertisingAccountWithFlag.vue?vue&type=template&id=4995f08c&scoped=true"
import script from "./AdvertisingAccountWithFlag.vue?vue&type=script&lang=js"
export * from "./AdvertisingAccountWithFlag.vue?vue&type=script&lang=js"

import "./AdvertisingAccountWithFlag.vue?vue&type=style&index=0&id=4995f08c&scoped=true&lang=scss"
import "./AdvertisingAccountWithFlag.vue?vue&type=style&index=1&id=4995f08c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4995f08c"]])

export default __exports__